
import React, { useState, useEffect, useContext } from "react";
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Footer from "../../components/Footer";
import { Context } from "../../common/context/Context";
import Sidebar from "./sidebar/Sidebar";
import MainAppbar from "./appbar/MainAppbar";
import useMediaQuery from "@mui/material/useMediaQuery";



const MainLayout = ({ children }) => {

    // const screenHeight = window.screen.height
    const browserScreenHeight = document.body.clientHeight

    // console.log("screenHeight:", screenHeight)

    const context = useContext(Context);

    /**for sidebar state */
    const [openSidebar, setOpenSidebar] = React.useState(true);


    /**if user is inactive close sidebar */
    useEffect(() => {
        if (!context?.isUserActive) {
            setOpenSidebar(false)
        }
    }, [context?.isUserActive])

    /**auto hidding and showing sidebar based on screen-size. for small devices it will be hidden and for other screens it will be shown  */
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    useEffect(() => {
        if (!!isSmallScreen) {
            setOpenSidebar(false)
        } else {
            setOpenSidebar(true)
        }
    }, [isSmallScreen])


    return (
        <React.Fragment>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />

                <MainAppbar
                    openSidebar={openSidebar}
                    setOpenSidebar={setOpenSidebar}
                />

                {/**drawer is visible only for authenticated user and active users */}
                {
                    (context?.adminUser || !context?.isUserActive) && (
                        <Sidebar
                            open={openSidebar}
                            setOpen={setOpenSidebar}
                        />
                    )
                }

                <Box
                    component="main"
                    sx={{
                        // backgroundColor: (theme) =>
                        //     theme.palette.mode === 'light'
                        //         ? theme.palette.grey[100]
                        //         : theme.palette.grey[900],
                        backgroundColor: "#f7f9fc",
                        flexGrow: 1,
                        height: '100vh',
                        overflow: 'auto',
                    }}
                >
                    <Toolbar />

                    <Container maxWidth="lg" sx={{ mt: 4, mb: 4, minHeight: browserScreenHeight }}>
                        {/**can pass all content here. */}
                        {children}
                    </Container>

                    <Footer />
                </Box>

            </Box >
            {/* <Settings /> */}
        </React.Fragment >
    )
}
export default MainLayout